import React, { useRef, useState } from "react";
import { Form, Alert } from "react-bootstrap";
import Button from "../../components/UI/Button/Button";
import { useAuth } from "../../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";

import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";

import userImageDefault from "../../img/default_user.png";
import Avatar from "../../components/UI/Avatar/Avatar";

import ImageTools from "../../components/ImageTools/ImageTools";

const debug = false;

export default function UpdateProfile() {
  const nameRef = useRef();
  const emailRef = useRef();
  const projectInfoRef = useRef();
  const posterRef = useRef();
  const specialityRef = useRef();
  const aboutRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const imageUploadRef = useRef();
  const telegramRef = useRef();
  const {
    currentUser,
    updatePassword,
    updateEmail,
    getUserData,
    updateUserData,
    logout,
  } = useAuth();
  const storage = getStorage();
  const storageProfilePictureRef = ref(
    storage,
    currentUser.uid + "/profile-picture_" + Date.now()
  );
  const [isNewAvatar, setIsNewAvatar] = useState(false);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const userData = getUserData();
  debug && console.log("UpdateProfile.js: Get user data:", userData);
  const [avatarSrc, setAvatarSrc] = useState(
    (userData && "photoURL" in userData && userData.photoURL) ||
      userImageDefault
  );

  async function handleLogout() {
    setError("");

    try {
      await logout();
      history.push("/login");
    } catch {
      setError("Ошибка выхода");
      window.scrollTo(0, 0);
    }
  }

  const promises = [];

  function handleAvatarChange() {
    setLoading(true); //block from updates
    try {
      //удалить, если в этой сессии пользователь уже загружал аватар, но не сохранил изменения
      if (isNewAvatar && avatarSrc && avatarSrc != userImageDefault) {
        var avatarRef = ref(storage, avatarSrc);
        if (avatarRef) {
          promises.push(deleteObject(avatarRef));
        }
      }

      setIsNewAvatar(true); //флаг для отслеживания загрузки нескольких изображений - для их удаления

      if (imageUploadRef.current.value) {
        debug &&
          console.log(
            "UpdateProfile.js: image to upload",
            imageUploadRef.current.files[0].name
          );

        //resize image
        ImageTools.resize(
          imageUploadRef.current.files[0],
          {
            width: 320, // maximum width
            height: 320, // maximum height
          },
          function (blob, didItResize) {
            // didItResize will be true if it managed to resize it, otherwise false (and will return the original file as 'blob')
            // document.getElementById('preview').src = window.URL.createObjectURL(blob);
            // you can also now upload this blob using an XHR.

            console.log(didItResize ? "Image resized" : "Failed resize image");

            // upload image to firebase
            uploadBytes(storageProfilePictureRef, blob).then(() => {
              getDownloadURL(storageProfilePictureRef).then((url) => {
                debug &&
                  console.log(
                    "UpdateProfile.js file uploaded",
                    storageProfilePictureRef.fullPath
                  );
                debug && console.log("UpdateProfile.js: avatar uploaded:", url);

                //remove old avatar image
                if (userData.photoURL) {
                  var oldAvatarRef = ref(storage, userData.photoURL);
                  if (oldAvatarRef) {
                    promises.push(deleteObject(oldAvatarRef));
                  }
                }
                setAvatarSrc(url);
                setLoading(false);
              });
            });
          }
        );
      }
    } catch {
      setError("Ошибка");
      window.scrollTo(0, 0);
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match");
    }

    setLoading(true);
    setError("");
    try {
      // update email
      if (emailRef.current.value !== currentUser.email) {
        promises.push(updateEmail(emailRef.current.value));
      }
      // update pwd
      if (passwordRef.current.value) {
        promises.push(updatePassword(passwordRef.current.value));
      }
      // update userData
      const newUserData = {
        name: nameRef.current.value,
        about: aboutRef.current.value,
        speciality: specialityRef.current.value,
        about: aboutRef.current.value,
        projectInfo: projectInfoRef.current.value,
        photoURL: avatarSrc != userImageDefault ? avatarSrc : userData.photoURL || '',
        telegram: telegramRef.current.value,
      };

      if (
        userData.name !== newUserData.name ||
        userData.about !== newUserData.about ||
        userData.speciality !== newUserData.speciality ||
        userData.about !== newUserData.about ||
        userData.projectInfo !== newUserData.projectInfo ||
        userData.photoURL !== avatarSrc ||
        userData.telegram !== newUserData.telegram
      ) {
        debug &&
          console.log("UpdateProfile.js: Update user data:", newUserData);
        promises.push(updateUserData(newUserData));
      }

      Promise.all(promises)
        .then(() => {
          history.push("/");
        })
        .catch(() => {
          setError("Failed to update account");
        })
        .finally(() => {
          setLoading(false);
        });
    } catch {
      setError("Ошибка");
      window.scrollTo(0, 0);
    }
  }

  return (
    <>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit} className="Form">
        <Form.Group id="photoURL" className="Form__group">
          <h2 className="Heading Form__title">Настройки профиля</h2>
          <Form.Label>Аватарка</Form.Label>

          <Form.Control
            type="file"
            ref={imageUploadRef}
            defaultValue={""}
            disabled={false}
            onChange={handleAvatarChange}
            accept="image/*"
            size="1"
          />

          <Avatar image={avatarSrc} size="small" />
        </Form.Group>

        <Form.Group id="name" className="Form__group">
          <Form.Label>Имя</Form.Label>
          <Form.Control
            type="text"
            ref={nameRef}
            required
            defaultValue={userData && userData.name}
          />
        </Form.Group>
        <Form.Group id="email" className="Form__group">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            ref={emailRef}
            required
            defaultValue={currentUser.email}
          />
        </Form.Group>
        <Form.Group id="tg" className="Form__group">
          <Form.Label>Телеграм</Form.Label>
          <Form.Control
            type="text"
            ref={telegramRef}
            defaultValue={userData && userData.telegram}
          />
        </Form.Group>
        <Form.Group id="projectInfo" className="Form__group">
          <Form.Label>О проекте</Form.Label>
          <Form.Control
            type="textarea"
            ref={projectInfoRef}
            defaultValue={userData && userData.projectInfo}
          />
        </Form.Group>
        <Form.Group id="speciality" className="Form__group">
          <Form.Label>Специальность</Form.Label>
          <Form.Control
            type="text"
            ref={specialityRef}
            defaultValue={userData && userData.speciality}
          />
        </Form.Group>
        <Form.Group id="about" className="Form__group">
          <Form.Label>Обо мне</Form.Label>
          <Form.Control
            type="text"
            ref={aboutRef}
            defaultValue={userData && userData.about}
          />
        </Form.Group>
        <Form.Group id="poster" className="Form__group">
          <Form.Label>Проектный плакат</Form.Label>
          <Form.Control
            type="file"
            ref={posterRef}
            defaultValue={""}
            disabled={true}
          />
        </Form.Group>
        <Form.Group id="password" className="Form__group">
          <Form.Label>Пароль</Form.Label>
          <Form.Control
            type="password"
            ref={passwordRef}
            placeholder="Оставьте пустым, чтобы не менять"
          />
        </Form.Group>
        <Form.Group id="password-confirm" className="Form__group">
          <Form.Label>Подтверждение</Form.Label>
          <Form.Control
            type="password"
            ref={passwordConfirmRef}
            placeholder="Оставьте пустым, чтобы не менять"
          />
        </Form.Group>
        <Form.Group className="Form__group">
          <a onClick={handleLogout}>Выход из системы</a>
        </Form.Group>
        {error && <Alert variant="danger">{error}</Alert>}
        <Button disabled={loading} className="Form__submit" type="submit">
          Сохранить
        </Button>
      </Form>
    </>
  );
}
